import React from 'react';
import styled from 'styled-components';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';

export const CapTransactionsLoader = () => {
	return (
		<CapTransactionsDiv>
			<CapTransactionsLoaderDiv>
				<Icon variant="cap-loader" size="xxl" />
				<CapTransactionsLoaderTitle>Fetching data...</CapTransactionsLoaderTitle>
				<CapTransactionsLoaderDescription>
					We're checking for transactions with matching details. This may take a few
					moments.
				</CapTransactionsLoaderDescription>
			</CapTransactionsLoaderDiv>
		</CapTransactionsDiv>
	);
};

const CapTransactionsDiv = styled.div`
	width: 100%;
	min-height: 400px;
	display: flex;
	align-items: center;
	justify-content: center;
`;

const CapTransactionsLoaderDiv = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 16px;
	max-width: 330px;
	text-align: center;
`;

const CapTransactionsLoaderTitle = styled.div`
	font-weight: 200;
	font-size: 25px;
	line-height: 22px;
	color: #0e171c;
`;

const CapTransactionsLoaderDescription = styled.div`
	font-weight: 400;
	font-size: 14px;
	line-height: 20px;
	color: #15232b;
`;
